import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { HeaderService } from 'src/app/core/services/header/header.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./public-layout.component.css'],
  styles: [
    `
      router-outlet {
        display: contents;
      }
    `,
  ],
  standalone: false,
})
export class PublicLayoutComponent implements OnInit, OnDestroy {
  copyrightYear: number = new Date().getFullYear();

  showBanner = signal(false);

  siteUrl: string = environment.siteUrl;

  private hideSub: Subscription | null = null;

  private headerService = inject(HeaderService);

  ngOnInit(): void {
    this.headerService.hideNav();
    const shown = sessionStorage.getItem('domainBannerShown');

    if (shown !== null) {
      this.showBanner.set(false);
      return;
    }

    sessionStorage.setItem('domainBannerShown', '1');
    this.showBanner.set(true);

    // Auto-hide after 20s
    this.hideSub = timer(20_000).subscribe(() => {
      this.showBanner.set(false);
    });
  }

  ngOnDestroy(): void {
    this.hideSub?.unsubscribe();
  }
}
